<template>
  <v-dialog v-model="dialog" max-width="900px" scrollable>
    <v-card v-if="layer">
      <v-card-title class="headline pb-2 border-bottom">
        Thống kê & Biểu đồ - {{ layer.name }}
      </v-card-title>
      <v-card-text class="pt-4">
        <!-- Phần cấu hình (Phase 3) -->
        <LayerChartSettings :layerId="layer.id" :datastoreDetailId="layer.datastore_detail_id"
          @preview="handlePreview" />

        <!-- Phần Preview (Phase 4) -->
        <div v-show="showPreview">
          <v-divider class="my-4"></v-divider>
          <div class="d-flex align-center justify-space-between mb-1">
            <h4 class="mb-0">Xem trước Biểu đồ</h4>
            <v-btn icon small @click="showPreview = false" title="Đóng xem trước">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <LayerChartPreview ref="preview" :layerId="layer.id" />
        </div>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <base-button @click="close" outlined>Đóng</base-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LayerChartSettings from '@components/layer/LayerChartSettings.vue'
import LayerChartPreview from '@components/layer/LayerChartPreview.vue'

export default {
  name: 'LayerChartDialog',
  components: { LayerChartSettings, LayerChartPreview },
  data() {
    return {
      dialog: false,
      layer: null,
      showPreview: false,
    }
  },
  methods: {
    open(item) {
      this.layer = item;
      this.dialog = true;
      this.showPreview = false;
    },
    close() {
      this.dialog = false;
      this.layer = null;
    },
    async handlePreview(chartId) {
      this.showPreview = true;
      await this.$nextTick();
      if (this.$refs.preview) {
        await this.$refs.preview.init(); // Reload để nhận diện biểu đồ mới thêm nếu có
        this.$refs.preview.previewChart(chartId);
      }
    }
  }
}
</script>
